<template>
  <div>
    <div
      class="packht"
    >
      <div class="packtxt">
        <h5>统计排名工具</h5>
        <div class="imgcontainer" style="margin-top: 20px">
          <div
            style="padding: 17px 10px 10px 10px; margin-top: 20px"
            class="imgtop"
          >
            <TextTop></TextTop>
            <!-- <div>无论机构，还是散户，都需要对股票做财务分析。</div>
            <div>股票投资，还需要财务分析软件！！！</div> -->
          </div>
          <!-- <img
            src="../../assets/img/pic1.png"
            alt=""
            style="margin-left: -10px"
          /> -->
          <div class="container">
            <div class="left_part">
              <ul>
                <li
                  v-for="(item, index) in leftList"
                  :key="index"
                  @click="select(index)"
                  :class="selectIndex == index ? 'active' : ''"
                >
                  <a>{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="right_part" ref="box">
              <div v-if="showlist[2]">
                <p class="title" id="id5">工具三：财务选股</p>
                <p>
                  如何才能透过价格表象深挖个股价值，排除不及格的股票，找到优质股，是价值投资选股的一个难题。
                </p>
                <p>
                 <common-data name="appShortName_26" v-common-display/>财务选股有别与传统的技术面选股，可直击企业经营状况，通过对和企业经营息息相关的市场表现、经营能力、偿债能力、银行专项等多方面指标进行排名分析，逐步排除业绩表现差或表现平庸的企业，选出各行业内竞争力强、适合长期持有的优质股票。
                </p>
                <Imggs
                  :src="require('../../assets/img/cwxg.jpg')"
                  alt=""
                  @click.native="showimg(require('../../assets/img/cwxg.jpg'))"
                />
              </div>
               <div v-if="showlist[1]">
                <p class="title" id="id5">工具二：财务数据截面统计</p>
                <p>
                  不同行业的企业经营特点不同，选股标准也不同，如何才能快速建立行业标准，选出好行业，进一步精选好股票？
                </p>
                <p>
                 <common-data name="appShortName_26" v-common-display/>的截面统计工具，统计了行业内股票的市场表现、经营能力、偿债能力和银行专项等各类指标的分布情况，通过分析行业均值数据建立行业“及格线”，并参考市值TOP5企业的相关数据，快速建立行业“优秀”企业的评判标准。
                </p>
                <Imggs
                  :src="require('../../assets/img/hjmxg.jpg')"
                  alt=""
                  @click.native="showimg(require('../../assets/img/hjmxg.jpg'))"
                />
              </div>
              <div v-if="showlist[0]">
                <p class="title" id="idxg">工具一：财务表现排名</p>
                <p>
                  都是同类企业，明明A比B的每股收益高，为什么A的股价就是涨不过B？是我看错了？还是大家都看错了？其实有时候可能是数据“出错了”！
                </p>
                <p>
                  传统软件将季报和年报、季报和半年报的数据放在一起展示，3个月的收益和6个月的收益没有可比性，已经失去了对比的意义。
                </p>
                <p>
                  <common-data name="appShortName_26" v-common-display/>的财务表现对一系列关键性财务指标数据进行了深加工处理，使用TTM算法将统计时间拉齐为12个月，可直接排序选股、指导交易。
                </p>
                <Imggs
                  :src="require('../../assets/img/cwbx.jpg')"
                  alt=""
                  @click.native="showimg(require('../../assets/img/cwbx.jpg'))"
                />
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <Baseimg :src="src" :show="ifimg" @change="ifimg = false" />
  </div>
</template>

<script>
import Baseimg from "../view/frame/Baseimg.vue";
import Imggs from "../view/frame/Imggs.vue";
export default {
  components: { Baseimg, Imggs },
  data() {
    return {
      leftList: [


        { name: "财务表现排名" },
        { name: "财务数据截面统计" },
        { name: "财务选股" },

      ],
      showlist: [
        true,
        false,
        false,
      ],
      selectIndex: 0,
      src: "",
      ifimg: false,
    };
  },
  methods: {
    select(index) {
      // console.log(1);
      this.selectIndex = index;
      this.showlist.forEach((el, idx) => {
        this.showlist[idx] = false;
      });
      this.showlist[index] = true;
      // this.custormAnchor(`id${index + 1}`);
    },
    showimg(e) {
      console.log(e);
      this.src = e;
      this.ifimg = true;
    },
    // custormAnchor(anchorName) {
    //   var target = document.getElementById(anchorName);
    //   if (target !== null) {
    //     this.$refs.box.scrollTop = target.offsetTop;
    //   }
    // },
  },
  mounted() {
    this.select(this.$route.params.id);
  },
};
</script>

<style scoped>
.packht {
  min-height: 600px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=11) no-repeat top;
  overflow: hidden;
}
.packtxt {
  width: 990px;
  margin: 0 auto;
  margin-top: 236px;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  padding: 30px 30px 0 30px;
}
.packtxt h5 {
  font-size: 22px;
  color: #5f5f5f;
  border-bottom: 1px dashed #7f7f7f;

  line-height: 40px;
  margin: 0 auto;
}
.img_box {
  height: 200px;
  margin-top: 20px;
  /* background: #ccc; */
  position: relative;
}
.container {
  width: 100%;
  position: relative;
  /* height: 660px; */
  background: white;
  margin-top: 20px;
}
.right_part::-webkit-scrollbar {
  width: 0;
}
.left_part {
  display: inline-block;
  width: 195px;
  height: 100%;
}
.left_part .title {
  width: calc(100% - 20px);
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  /* font-weight: bold; */
  background: url(../../assets/img/ts.jpg) no-repeat center;
  background-size: 100% 100%;
  vertical-align: top;
  color: #fff;
  padding-left: 20px;
}
.left_part ul li {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  font-size: 15px;
  color: #827373;
  /* margin-top: 1px; */
}
.left_part ul li:hover {
  color: #b56f6f;
}
.left_part ul li.active {
  background: #e57373;
  /* box-shadow: 2px 4px 4px #bebcbc inset; */
  color: white;
}
.left_part ul li a {
  width: 85%;
  margin: 0 auto;
  display: block;
  border-bottom: 1px solid #ececec;
  text-indent: 1em;
  position: relative;
  top: -1px;
}
.left_part ul li.active  a{
  border-bottom: none;
}
.right_part {
  display: inline-block;
  width: 695px;
  height: 100%;
  vertical-align: top;
  background: #f5f5f5;
  /* overflow-y: auto; */
  padding: 20px 40px;
  color: #8a8a8a;
  /* box-shadow: -4px 4px 4px #bebcbc inset; */
  background: #efefef;
}
.right_part p {
  text-indent: 2em;
  padding: 5px 0;
  font-size: 14px;
  text-align: justify;
  line-height: 24px;
}
.right_part img {
  margin: 20px auto;
  display: block;
}
.right_part .title {
  font-size: 16px;
  font-weight: bold;
  text-indent: 0;
  color: #7e4040;
}
.img-link {
  position: absolute;
  display: block;
  height: 20px;
  width: 70px;
}
.img-link div {
  width: 100%;
  height: 100%;
}
.imgcontainer {
  padding: 0 10px;
  background: #f5f5f5;
}
.imgtop div {
  color: #292929;
  text-indent: 2em;
  font-size: 15px;
  padding: 5px 0;
}
</style>